import { styled, keyframes } from "@pigment-css/react";
import { SidePanelContainer, DateColumn, DatedListDivider } from "../ui";
import { Flex } from "../../primitives/Flex";

const shimmer = keyframes({
  "0%": { backgroundPosition: "-200px 0" },
  "100%": { backgroundPosition: "200px 0" },
});

const SkeletonElement = styled("div")(({ theme }) => ({
  borderRadius: theme.managementView.radius[10],
  background: `linear-gradient(90deg, ${theme.colors.neutral[200]} 0%, ${theme.colors.neutral[100]} 50%, ${theme.colors.neutral[200]} 100%)`,
  backgroundSize: "400px 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
}));

const HeaderTitleSkeleton = styled(SkeletonElement)({
  height: "28px",
  width: "60%",
});

const HeaderSubtitleSkeleton = styled(SkeletonElement)({
  height: "20px",
  width: "40%",
});

const SectionTitleSkeleton = styled(SkeletonElement)({
  height: "20px",
  width: "100px",
});

const ChipSkeleton = styled(SkeletonElement)({
  height: "32px",
  width: "56px",
  flexShrink: 0,
  borderRadius: "16px",
});

const TodoTitleSkeleton = styled(SkeletonElement)({
  height: "18px",
  width: "80%",
});

const TodoDescriptionSkeleton = styled(SkeletonElement)({
  height: "16px",
  width: "60%",
});

const TodoDetailSkeleton = styled(SkeletonElement)({
  height: "14px",
  width: "100px",
});

const TodoListContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
});

const TodoCardSkeleton = () => (
  <Flex gap={16} align="start">
    <DateColumn>
      <ChipSkeleton />
    </DateColumn>
    <Flex direction="column" align="start" gap={24} style={{ flex: 1 }}>
      <Flex direction="column" gap={2} align="start" style={{ width: "100%" }}>
        <TodoTitleSkeleton />
        <TodoDescriptionSkeleton />
      </Flex>
      <TodoDetailSkeleton />
    </Flex>
  </Flex>
);

export const OpenTodosSidePanelSkeleton = () => {
  return (
    <SidePanelContainer>
      <Flex direction="column" gap={4}>
        <HeaderTitleSkeleton />
        <HeaderSubtitleSkeleton />
      </Flex>

      <Flex direction="column" gap={16}>
        <SectionTitleSkeleton />
        <TodoListContainer>
          <TodoCardSkeleton />
          <DatedListDivider />
          <TodoCardSkeleton />
        </TodoListContainer>
      </Flex>

      <Flex direction="column" gap={16}>
        <SectionTitleSkeleton />
        <TodoListContainer>
          <TodoCardSkeleton />
          <DatedListDivider />
          <TodoCardSkeleton />
          <DatedListDivider />
          <TodoCardSkeleton />
        </TodoListContainer>
      </Flex>
    </SidePanelContainer>
  );
};
